var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefuseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17038",
    "data-name": "Groupe 17038",
    transform: "translate(-1363.482 -3272.482)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5502",
    "data-name": "Rectangle 5502",
    width: 36,
    height: 36,
    rx: 10,
    transform: "translate(1363.482 3272.482)",
    fill: "#e84f35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close-circle",
    "data-name": "Icon ionic-ios-close-circle",
    d: "M12.375,3.375a9,9,0,1,0,9,9A9,9,0,0,0,12.375,3.375Zm2.28,12.258-2.28-2.28-2.28,2.28a.691.691,0,1,1-.978-.978l2.28-2.28-2.28-2.28a.691.691,0,0,1,.978-.978l2.28,2.28,2.28-2.28a.691.691,0,1,1,.978.978l-2.28,2.28,2.28,2.28a.7.7,0,0,1,0,.978A.687.687,0,0,1,14.655,15.633Z",
    transform: "translate(1369.107 3278.107)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefuseButton);
export default __webpack_public_path__ + "static/media/refuseButton.d93594b906a38e5b567a8546129bc1a8.svg";
export { ForwardRef as ReactComponent };